module.exports = __webpack_public_path__ + "img/CG.f2e458f5.svg";